module.exports = __webpack_public_path__ + "static/img/img2-1.0797e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img2-1.png
// module id = 6seh
// module chunks = 10